export default "__VITE_ASSET__B7N9LCBR__"